import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ClientUtilities } from "app/utils/client-utils";
import { Observable } from "rxjs";
import {environment} from '../../environments/environment';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
    allowedUrls = [{url: '/hybridity/api/sessions', method: 'POST'}];
    authToken = !environment.loadedInVCRemotePlugin ? atob(sessionStorage.getItem('hcx-auth-token')) : null;
    authTokenName = !environment.loadedInVCRemotePlugin ? sessionStorage.getItem('hcx-auth-token-name') : null;  
    constructor(){
        const top = ClientUtilities.getRootWindowInSameDomain(window);
        top.addEventListener('message', (event) => {
            if(event.source && event.data === 'hcx:retrieve:token'){
                event.source.postMessage({msgType:'hcx:token', token: this.authToken ? btoa(this.authToken) : null, tokenName: this.authTokenName}, event.origin);
            }
        });
        if(this.authToken) {
            environment.token = btoa(this.authToken);
        }
    }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let isRequestAllowed = false;
        isRequestAllowed = this.allowedUrls.some(item => req.url.indexOf(item.url) > -1 && item.method === req.method);
        if(isRequestAllowed) {
            return next.handle(req)
            .do(res => {
                if(res instanceof HttpResponse) {
                    if(req.url.indexOf(this.allowedUrls[0].url) > -1 && req.method === 'POST' && res.status === 200) {
                        this.authToken = res.headers.get(res.headers.get('auth_token_name'));
                        this.authTokenName = res.headers.get('auth_token_name');
                        environment.token = btoa(this.authToken);
                        /**
                         * for standalone ui persist token in session storage to retrieve back on full page reload.
                         * For remote plugin no need to persist as again token exchange would happen to full page reload.
                         * For plugin ui not required. proxy server handles token management.
                         */
                        if(!environment.loadedInVCRemotePlugin){
                            sessionStorage.setItem('hcx-auth-token', btoa(this.authToken));
                            sessionStorage.setItem('hcx-auth-token-name', res.headers.get('auth_token_name'));
                        }
                        console.debug(`parsed auth token`);
                    } else if(req.url.indexOf(this.allowedUrls[0].url) > -1 && req.method === 'DELETE' && res.status === 200) {
                        console.debug(`logout success`);
                        this.authToken = null;
                        sessionStorage.removeItem('hcx-auth-token');
                        sessionStorage.removeItem('hcx-auth-token-name');
                    }
                }
            });
        }else {
            // send auth token in request header
            const authTokenName = this.authTokenName || null;
            if(authTokenName && this.authToken && req.url.indexOf('/hybridity/api')>-1) {
                const headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                };
                headers[authTokenName] = this.authToken;
                const clonedRequest = req.clone({
                    setHeaders: headers
                });
                return next.handle(clonedRequest);    
            }
            return next.handle(req);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/interceptors/auth-token-interceptor.ts